/**
 * De 32 nodale omgevingen: elke omgeving is een oppositie-paar van poorten dat
 * pal tegenover elkaar in de Rave Mandala staat — dezelfde as waarop de zuid-
 * en noordnode altijd samen liggen. Canonieke volgorde: oplopend op de laagste
 * poort van het paar, zodat een omgeving snel terug te vinden is vanuit de
 * poortnummers in het levenskruis.
 *
 * Bron: "The 32 Nodal Environments" (Ra Uru Hu, 2005) —
 * `docs/human-design/books/The 32 Nodal Environments by Ra Uru Hu.md`. De
 * oppositie-eigenschap wordt in de spec geverifieerd tegen
 * `MANDALA_GATE_SEQUENCE_CCW` (offset 32 in het wiel).
 */
export type HdNodalEnvironmentPair = readonly [number, number];

export const HD_NODAL_ENVIRONMENT_PAIRS: readonly HdNodalEnvironmentPair[] = [
  [1, 2], [3, 50], [4, 49], [5, 35], [6, 36], [7, 13], [8, 14], [9, 16],
  [10, 15], [11, 12], [17, 18], [19, 33], [20, 34], [21, 48], [22, 47], [23, 43],
  [24, 44], [25, 46], [26, 45], [27, 28], [29, 30], [31, 41], [32, 42], [37, 40],
  [38, 39], [51, 57], [52, 58], [53, 54], [55, 59], [56, 60], [61, 62], [63, 64],
];

/** Bestands-/vertaalsleutel van een omgeving: `"4-49"`. */
export function hdNodalEnvironmentKey(pair: HdNodalEnvironmentPair): string {
  return `${pair[0]}-${pair[1]}`;
}

/** Weergavelabel van een omgeving: `"4/49"`. */
export function hdNodalEnvironmentLabel(pair: HdNodalEnvironmentPair): string {
  return `${pair[0]}/${pair[1]}`;
}

const PAIR_BY_GATE: ReadonlyMap<number, HdNodalEnvironmentPair> = new Map(
  HD_NODAL_ENVIRONMENT_PAIRS.flatMap(pair => [
    [pair[0], pair] as const,
    [pair[1], pair] as const,
  ]),
);

/** Het omgeving-paar waar deze poort deel van uitmaakt, of `undefined` buiten 1..64. */
export function hdNodalEnvironmentPairForGate(gate: number): HdNodalEnvironmentPair | undefined {
  return PAIR_BY_GATE.get(gate);
}
